import React, { useState, useEffect, useCallback } from 'react';
import api, { getToken, setToken, clearToken } from './services/api';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [branding, setBranding] = useState({ app_title: 'Gestion', short_name: 'Gestion', primary_color: '#0891b2', logo_url: '' });

  // Applique le branding (titre + couleur accent) au runtime
  const applyBranding = useCallback((b) => {
    setBranding(b);
    if (b.app_title) document.title = b.app_title;
    if (b.primary_color) document.documentElement.style.setProperty('--color-accent', b.primary_color);
  }, []);

  // Dark mode (persisté)
  useEffect(() => {
    const dark = localStorage.getItem('immo-dark') === 'true';
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
  }, []);

  // Au démarrage : branding public + restauration de session
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/config');
        applyBranding(data);
      } catch { /* branding par défaut */ }

      if (getToken()) {
        try {
          const { data } = await api.get('/auth/me');
          setUser(data.user);
        } catch {
          clearToken();
        }
      }
      setLoading(false);
    })();
  }, [applyBranding]);

  const handleLogin = (token, u) => {
    setToken(token);
    setUser(u);
  };

  const handleLogout = () => {
    clearToken();
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)' }}>
        Chargement…
      </div>
    );
  }

  if (!user) return <Login onLogin={handleLogin} branding={branding} />;
  return <Dashboard user={user} setUser={setUser} branding={branding} onLogout={handleLogout} />;
}
